import React from 'react';
export function HeroSection() {
  return <section id="hero-section" className="relative w-full flex flex-col text-center px-4 pt-6 pb-8 sm:pt-12 sm:pb-20 items-center justify-center bg-bg-main overflow-hidden" data-id="element-121">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-primary/10 rounded-full blur-[80px] pointer-events-none" data-id="element-122"></div>

      {/* Attention Badge */}
      <div className="relative bg-badge-red/10 border border-badge-red/20 text-badge-red font-bold text-[10px] sm:text-xs px-3 py-1 sm:px-4 sm:py-1.5 rounded-full mb-4 sm:mb-6 flex items-center gap-1.5 sm:gap-2 shadow-[0_2px_10px_rgba(201,112,100,0.05)] animate-[fadeInDown_0.5s_ease-out_both]" data-id="element-123">
        <span className="text-sm sm:text-base" data-id="element-124">🧘‍♀️</span>
        <span className="hidden sm:inline" data-id="element-125">
          ATTENTION: AUSTRALIAN PILATES INSTRUCTORS TIRED OF SACRIFICING THEIR
          WEEKENDS TO CLASS PLANNING
        </span>
        <span className="sm:hidden" data-id="element-126">
          ATTENTION: AUSTRALIAN PILATES INSTRUCTORS
        </span>
      </div>

      {/* Main headline */}
      <h1 className="relative font-serif font-black text-text-main max-w-5xl text-[28px] leading-[1.15] sm:text-5xl md:text-6xl sm:leading-[1.1] mb-4 sm:mb-6 tracking-tight animate-[fadeInUp_0.5s_ease-out_0.1s_both]" data-id="element-127">
        Plan your entire year of Pilates classes in{' '}
        <span className="text-primary" data-id="element-128">just 5 minutes.</span>
      </h1>

      {/* Subheadline */}
      <p className="relative text-text-sec text-sm sm:text-xl font-medium leading-relaxed mb-4 sm:mb-8 max-w-3xl mx-auto sm:bg-white/40 sm:backdrop-blur-sm sm:border sm:border-white/60 sm:border-l-4 sm:border-l-primary sm:px-8 sm:py-5 sm:rounded-r-xl sm:shadow-[0_4px_20px_rgba(201,137,155,0.08)] sm:text-left animate-[fadeInUp_0.5s_ease-out_0.2s_both]" data-id="element-129">
        The <span className="text-primary font-bold" data-id="element-130">"Open & Teach"</span> Vault
        with ready-to-go sessions for Matwork, Small Props, and Special
        Populations.{' '}
        <span className="hidden sm:inline text-text-main font-semibold" data-id="element-131">
          Reclaim your Sunday nights.
        </span>
      </p>

      {/* Mockup image */}
      <div className="relative w-full max-w-[280px] sm:max-w-[460px] md:max-w-[520px] mx-auto mb-4 sm:mb-8 animate-[fadeInScale_0.6s_ease-out_0.3s_both]" data-id="element-132">
        <div className="absolute inset-0 bg-primary/10 blur-[40px] rounded-full" data-id="element-133"></div>
        <img src="https://cdn.magicpatterns.com/uploads/uSuqfamc9ydDwnyFBHNuC9/1500-CLIENTE-SODDISFATTI-_18_.webp" alt="The Pilates Pack — Complete Australian Edition" className="relative w-full h-auto object-contain drop-shadow-[0_10px_30px_rgba(61,42,58,0.15)]" width={520} height={390} fetchPriority="high" decoding="async" sizes="(max-width: 640px) 280px, (max-width: 768px) 460px, 520px" data-id="element-134" />
      </div>

      {/* Stars + Urgency */}
      <div className="relative flex flex-col items-center gap-2 sm:gap-2 mb-4 sm:mb-6 animate-[fadeIn_0.5s_ease-out_0.4s_both]" data-id="element-135">
        <div className="flex items-center gap-2" data-id="element-136">
          <span className="text-secondary text-sm sm:text-lg" data-id="element-137">⭐⭐⭐⭐⭐</span>
          <span className="text-text-sec text-xs sm:text-base font-medium" data-id="element-138">
            4.9/5 (+800 Verified Reviews)
          </span>
        </div>
        <span className="text-primary font-bold text-xs sm:text-sm bg-primary/10 px-3 py-1 rounded-full border border-primary/20" data-id="element-139">
          🔥 62 instructors across Australia joined the Vault today
        </span>
      </div>

      {/* CTA Button */}
      <a href="#pricing" className="relative btn-primary-pulse bg-cta-green font-black text-base sm:text-xl px-6 sm:px-12 py-4 sm:py-5 rounded-2xl hover:bg-cta-green-hover transition-all inline-block mb-3 sm:mb-4 w-full sm:w-auto max-w-xl text-white shadow-[0_8px_25px_rgba(16,185,129,0.25)] border border-white/20 animate-[fadeInUp_0.5s_ease-out_0.5s_both]" data-id="element-140">
        👉 YES! I WANT TO RECLAIM MY WEEKEND
      </a>

      {/* Trust badges */}
      <p className="relative text-text-sec text-[11px] sm:text-sm font-medium flex items-center justify-center gap-1.5 sm:gap-2 flex-wrap animate-[fadeIn_0.5s_ease-out_0.6s_both]" data-id="element-141">
        <span data-id="element-142">⚡ Instant Digital Access</span>
        <span data-id="element-143">•</span>
        <span data-id="element-144">🛡️ 14-Day Money Back Guarantee</span>
        <span data-id="element-145">•</span>
        <span data-id="element-146">💳 One-Time Payment</span>
      </p>
    </section>;
}